module.exports = __webpack_public_path__ + "img/align-left-solid.17cdc156.svg";